import './styles/login.css'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

//Extras
import { fontType, main } from '../assets/extras'
import { validateEmail } from '../assets/validator'
import { signInWithEmailAndPassword } from 'firebase/auth'
import { auth, db } from '../assets/connections'
import { collection, doc, getDoc, getDocs, query } from 'firebase/firestore'

//Components
import Loader from '../components/loader'
import Imagen from '../assets/images/tenista_icon_gp.png'
import Snack from '../components/snack'
import { IoMdClose } from "react-icons/io"

const Login = () => {

    document.title = "Tenista Dashboard"

    const [ variables, setVariables ] = useState({
        loading: true,
        email: "",
        password: "",
        academies: [],
        users: []
    })

    const navigate = useNavigate()

    //Control del mensaje snack
    const showMessage = (message, status) => {
        let contSnack = document.getElementById("contSnack")

        let snack = document.createElement("div")
        snack.classList.add("snack")

        snack.innerHTML = status == "success" ?
            "<i class='fa-regular fa-circle-check fa-beat' style='color: #56d600;'></i>" +
            "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
            "<div className='snackBar' style='background-color: #56d600;'></div>"
            : status == "warning" ?
                "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" +
                "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                "<div className='snackBar' style='background-color: #f9b92f;'></div>"
                : status == "error" ?
                    "<i class='fa-solid fa-circle-xmark fa-beat' style='color: #c20000;'></i>" +
                    "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                    "<div className='snackBar' style='background-color: #c20000;'></div>"
                    : ""

        contSnack.appendChild(snack)
        setTimeout(() => {
            snack.remove()
        }, 5000)
    }

    //Funcion que valida los datos del usuario
    const validateFields = () => {
        if(variables.email === "" || validateEmail(variables.email) === false){
            showMessage("Debes ingresar un correo valido", "warning")
        } else {
            var cont = 0
            variables.academies.map(v => {
                if(v.id === variables.email){
                    cont ++
                }
            })
            if(cont > 0){
                if(variables.password != ""){
                    setVariables(prev => ({
                        ...prev,
                        loading: true
                    }))
                    login()
                } else {
                    showMessage("Debes ingresar una contraseña", "warning")
                }
            } else {
                showMessage("El correo no esta registrado", "warning")
            }
        }
    }

    //Funcion que obtiene la referencia de la academia
    const getReference = async (correo, clave) => {
        await getDoc(doc(db, "Academias", correo)).then(r => {
            var name = ""
            for(let i = 0; i < variables.academies.length; i++){
                if(variables.academies[i].id === correo){
                    name = variables.academies[i].nombre_academia
                    break
                }
            }
            if(r.exists){

                const token = localStorage.setItem("authToken", JSON.stringify({
                    ref: r.ref.path,
                    academia: correo,
                    clave: clave,
                    nombre_academia: name
                }))

                const users = localStorage.getItem("users")

                if(!users){
                    var aux = [{
                        ref: r.ref.path,
                        academia: correo,
                        clave: clave,
                        nombre_academia: name
                    }]

                    localStorage.setItem("users", JSON.stringify(aux))
                } else {
                    var aux = JSON.parse(users)

                    //Validamos si ya existe ese usario en el registro
                    var cont = 0
                    for(let i = 0; i < aux.length; i++){
                        if(aux[i].academia === correo){
                            cont ++
                            break
                        }
                    }

                    if(cont === 0){
                        aux.push({
                            ref: r.ref.path,
                            academia: correo,
                            clave: clave,
                            nombre_academia: name
                        })
                        localStorage.setItem("users", JSON.stringify(aux))
                    }
                }

                navigate("/home", { replace: true })
                
            } else {
                setVariables(prev => ({
                    ...prev,
                    loading: false
                }))
                showMessage("No se encontro el usuario", "error")
            }
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Error de conexion", "error")
        })
    }

    //Funcion que ejecuta el inicio de sesion con las credenciales
    const login = async () => {  
        await signInWithEmailAndPassword(auth, variables.email, variables.password).then(r => {
            getReference(variables.email, variables.password)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                if(e.code == "auth/wrong-password"){
                    showMessage("Clave incorrecta", "error")
                } else if(e.code == "auth/user-not-found"){
                    showMessage("Correo invalido", "error")
                } else {
                    showMessage("Error de conexion", "error")
                }
            }, 100)
        })
    }

    //Funcion que obtiene a todas las academias
    const getAcademies = async (users) => {
        await getDocs(query(collection(db, "Academias"))).then(r => {
            var aux = []
            r.docs.map(v => (
                aux.push({
                    id: v.id,
                    nombre_academia: v.data().nombre_academia
                })
            ))

            setVariables(prev => ({
                ...prev,
                academies: aux,
                users: users ? JSON.parse(users) : [],
                loading: false
            }))
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }

    //Funcion que valida si una sesion ya fue iniciada
    const getCurrSession = async () => {
      const token = localStorage.getItem("authToken")
      
      if(token){
        navigate("/home")
      } else {

        const users = localStorage.getItem("users")

        getAcademies(users)
      }
    }

    useEffect(() => {
        getCurrSession()
    }, [])

    if(variables.loading)
    return (
        <Loader
            loading={variables.loading}
        />
    )

    if(!variables.loading)
    return (
        <div className='mainLogin' style={{
            backgroundColor: main
        }}>

            <Snack />

            <img src={Imagen} style={{
                width:200,
            }} />

            <div className='contForm'>
                <div className='item'>
                    <p style={{
                        fontFamily: fontType.text
                    }}>Correo electronico </p>
                    <input
                        style={{
                            fontFamily: fontType.text
                        }}
                        value={variables.email}
                        onChange={e => {
                            const t = e.target.value.trim()
                            
                            setVariables(prev  => ({
                                ...prev,
                                email: t
                            }))
                        }}
                    />
                </div>
                <div className='item'>
                    <p style={{
                        fontFamily: fontType.text
                    }}>Contraseña </p>
                    <input
                        style={{
                            fontFamily: fontType.text
                        }}
                        value={variables.password}
                        onChange={e => {
                            const t = e.target.value.trim()
                            
                            setVariables(prev  => ({
                                ...prev,
                                password: t
                            }))
                        }}
                        type='password'
                    />
                </div>
                <div className='item'>
                    <button style={{
                        fontFamily: fontType.title
                    }}
                        onClick={() => {
                            validateFields()
                        }}
                    >
                        INICIAR SESION
                    </button>
                </div>

                <div className='contUsers'>
                    {
                        variables.users.map((v, i) => {
                            return (
                                <div className='user'>
                                    <p style={{
                                        fontFamily: fontType.text
                                    }} onClick={() => {

                                        setVariables(prev => ({
                                            ...prev,
                                            loading: true
                                        }))

                                        setTimeout(() => {
                                            getReference(v.academia, v.clave)
                                        }, 100)

                                    }}>{v.nombre_academia}</p>
                                    <IoMdClose size={20} color='red' style={{
                                        cursor: "pointer"
                                    }} onClick={() => {
                                        //Primero obtenemos los usuarios
                                        var users = localStorage.getItem("users")
                                        users = JSON.parse(users)

                                        users.splice(i, 1)
                                        variables.users.splice(i, 1)

                                        if(users.length === 0){
                                            localStorage.removeItem("users")
                                        } else {
                                            localStorage.setItem("users", JSON.stringify(users))
                                        }

                                        setVariables(prev => ({
                                            ...prev
                                        }))
                                    }} />
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default Login